export default "Estoque"